export default "__VITE_ASSET__ZGpQBhAC__"